<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate"> Overall Overview
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content #pageContainer>
    <form [formGroup]="searchForm">
        <div class="flex justify-between w-full mb-3">
            <div class="flex justify-start w-3/4">
                <div class="flex w-1/2">
                    <div class="text-primary pt-4">Field Name</div>
                    <mat-form-field class="ml-2 w-1/2">
                        <mat-select placeholder="Select Platform" formControlName="Field">
                            <mat-option [value]="'all'"> All </mat-option>
                            <mat-option *ngFor="let field of fieldList" [value]="field"> {{ field.fieldLongName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="flex w-1/2">
                    <div class="text-primary pt-4">Platform Name</div>
                    <mat-form-field class="ml-2 w-1/2">
                        <mat-select placeholder="Select Platform" formControlName="Platform">
                            <mat-option [value]="'all'"> All </mat-option>
                            <mat-option *ngFor="let platform of platformList" [value]="platform.platformLongName">
                                {{ platform.platformLongName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="flex justify-around">
                <div class="w-17 mx-2">
                    <mat-form-field class="w-full">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <button class="btn btn-outline" (click)="exportToExcel()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                </button>
            </div>
        </div>
    </form>

    <div class="grid overflow-x-auto">
        <!-- Header -->
        <div class="table-overall-overview-well-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
            matSort matSortDisableClear>
            <div class="border py-8 text-center">
                No
            </div>

            <div [mat-sort-header]="'fieldName'" class="flex justify-center border py-4 my-custom-sort-header">
                Field
            </div>

            <div [mat-sort-header]="'platformName'" class="flex justify-center border py-4">
                Platform
            </div>

            <div [mat-sort-header]="'wellName'" class="flex justify-center border text-center py-4">
                Well
            </div>

            <div [mat-sort-header]="'stringName'" class="flex justify-center border text-center py-4">
                Well String
            </div>

            <div [mat-sort-header]="'productionStatus'" class="flex border justify-center py-4">
                Production Status
            </div>

            <div [mat-sort-header]="'updatedBy'" class="flex border justify-center py-4">
                Updated By
            </div>

            <div [mat-sort-header]="'updatedAt'" class="flex border justify-center py-4">
                Updated Date
            </div>
        </div>
        <!-- Rows -->
        <ng-container *ngIf="dt.rows.length; else noRecords">
            <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                <div class="table-overall-overview-well-grid grid items-center border-b"
                    [ngClass]="{'bg-primary-100': i % 2 }">

                    <!-- No -->
                    <div class="py-4 text-center">
                        {{startingIndex + i + 1}}.
                    </div>

                    <!-- Field Long Name -->
                    <div class="flex truncate justify-center">
                        {{ row.fieldName }}
                    </div>

                    <!-- Platform Long Name  -->
                    <div class="flex justify-center">
                        {{ row.platformName }}
                    </div>

                    <!-- Well Long Name  -->
                    <div class="flex justify-center">
                        {{ row.wellName }}
                    </div>

                    <!-- String Long Name  -->
                    <div class="text-center">
                        {{ row.stringName }}
                    </div>

                    <!-- Production Status -->
                    <div class="block text-center">
                        {{ row.productionStatus }}
                    </div>

                    <!-- Updated By -->
                    <div class="block text-center">
                        {{ row.updatedBy }}
                    </div>

                    <!-- Updated Date -->
                    <div class="block text-center">
                        {{ handleFormatDate(row.updatedAt,false) }}
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noRecords>
            <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                There are no records registered!
            </div>
        </ng-template>
    </div>

    <div
        class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
        <div class="content-center px-3">
            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'total' : 'totals' }} </div>

                <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                    [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                    [hidePageSize]="true" [showFirstLastButtons]="true">
                </mat-paginator>
        </div>

</mat-dialog-content>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>